import { CartAddEvent } from '@theme/events';
let adding = false;
document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-ca-upsell-add]');
  if (!button || adding) return;
  const root = button.closest('[data-ca-cart-upsell]');
  const status = root.querySelector('[data-ca-upsell-status]');
  const id = Number(button.dataset.caUpsellAdd);
  if (!Number.isSafeInteger(id) || id <= 0) return;
  adding = true;
  const buttons = [...document.querySelectorAll('[data-ca-upsell-add]')];
  buttons.forEach(b => { b.disabled = true; });
  button.textContent = 'Adding…';
  status.textContent = '';
  let added = false;
  try {
    const currentResponse = await fetch(`${root.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' } });
    if (!currentResponse.ok) throw new Error('Unable to check your bag. Please try again.');
    const current = await currentResponse.json();
    if (current.items.some(item => Number(item.variant_id) === id)) {
      status.textContent = 'This edition is already in your bag.';
      return;
    }
    const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(n => n.dataset.sectionId))].slice(0, 5);
    const response = await fetch(root.dataset.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({items: [{ id, quantity: 1 }], sections, sections_url: window.location.pathname}) });
    const result = await response.json();
    if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'Unable to add this edition. Please try again.');
    added = true;
    const latestResponse = await fetch(`${root.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' } });
    if (!latestResponse.ok || !sections.length || sections.some(s => !result.sections?.[s])) {
      window.location.assign(root.dataset.cartUrl);
      return;
    }
    const latest = await latestResponse.json();
    document.dispatchEvent(new CartAddEvent(result, 'ca-cart-upsells', {source:'ca-cart-upsells', itemCount:latest.item_count, sections:result.sections}));
  } catch (error) {
    if (added) { window.location.assign(root.dataset.cartUrl); return; }
    status.textContent = error.message || 'Unable to update your bag. Please try again.';
  } finally {
    adding = false;
    buttons.forEach(b => { b.disabled = false; });
    button.textContent = 'Add';
  }
});
